import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoaderVisible: false,
  requestToAddToCart: false,
  responseToAddToCart: false,
  requestToUpdateCart: false,
  responseToUpdateCart: false,
  requestToGetCartItemsCount: false,
  responseToGetCartItemsCount: false,
  addToCartResponse: {},
  cartError: {},
  cartCount: 0,
  selectedCartProduct: {},
  responseToGetCartItems: false,
  cartItems: [],
};

export const CartSlice = createSlice({
  name: "Cart",
  initialState,
  reducers: {
    requestAddToCart: (state) => {
      state.requestToAddToCart = true;
    },
    responseAddToCart: (state, action) => {
      state.requestToAddToCart = false;
      state.responseToAddToCart = true;
      state.addToCartResponse = action.payload;
    },
    failedAddToCart: (state, action) => {
      state.requestToAddToCart = false;
      state.responseToAddToCart = false;
      state.cartError = action.payload;
    },
    failedUpdateCart: (state, action) => {
      state.requestToUpdateCart = false;
      state.responseToUpdateCart = false;
      state.cartError = action.payload;
    },
    responseUpdateCart: (state) => {
      state.requestToUpdateCart = false;
      state.responseToUpdateCart = true;
    },
    requestUpdateCart: (state) => {
      state.requestToUpdateCart = true;
      state.responseToUpdateCart = false;
    },
    requestUpdateBaseProductQuantity: (state) => {
      state.requestToUpdateCart = true;
      state.responseToUpdateCart = false;
    },
    responseGetCartItemsCount: (state, action) => {
      state.requestToGetCartItemsCount = false;
      state.responseToGetCartItemsCount = true;
      state.cartCount = action.payload;
    },
    setIsLoaderVisible: (state, action) => {
      state.isLoaderVisible = action.payload;
    },
    responseGetCartItems: (state, action) => {
      state.responseToGetCartItems = true;
      state.cartItems = action.payload;
    },
    setCartItems: (state, action) => {
      state.requestToAddToCart = false;
      state.cartItems = action.payload;
    },
  },
});

export default CartSlice.reducer;
export const {
  responseGetCartItemsCount,
  setIsLoaderVisible,
  failedAddToCart,
  requestAddToCart,
  responseAddToCart,
  failedUpdateCart,
  responseUpdateCart,
  requestUpdateCart,
  requestUpdateBaseProductQuantity,
  responseGetCartItems,
  setCartItems,
} = CartSlice.actions;
